export default "__VITE_ASSET__8354cf6a__"